<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1QadLr/tc-custom/9781439677506.jpg?1737519620561" alt="This image is the cover for the book Rio Grande Sniper Killings, The, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rio Grande Sniper Killings, The, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p>Untangle the complex conspiracy that led to the tragic deaths of Charlotte Kay Elliott and Kevin Edwin Frase on the banks of the Rio Grande. On the night of July 13, 1980, a hitman fired a high-powered rifle into the crowd at Pepe's On the River, an outdoor bar in Mission, Texas. He missed his target, a witness in the Loop 360 drug case, but killed two young bystanders. While state court prosecutions for capital murder inexplicably faltered, a federal court gave the assassin a life sentence for attempted murder of a grand jury witness. A member of the judge's staff who was present throughout the trial, author John W. Primomo revisits the dramatic twists and turns surrounding this murder on the Rio Grande.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Primomo
      </h2>
      
      <p class="authorDescription body article">John W. Primomo served twenty-nine years as a U.S. magistrate judge for the Western District of Texas in San Antonio. He previously authored two books: The Appomattox Generals: The Parallel Lives of Joshua L. Chamberlain, U.S.A., and John B. Gordon, CSA, Commanders at the Surrender Ceremony of April 12, 1865 (2013) and Architect of Death at Auschwitz: A Biography of Rudolf Höss (2020). For thirty-plus years, he has volunteered with Camp Discovery, a summer camp in south Texas for children with cancer. He is also the president of the nonprofit corporation that operates Camp Discovery and several other camps for children with life-threatening illnesses and their families throughout the year.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5504688e